import React, { useState } from 'react'
import DocReviewBg from '../../../../assets/MemberBookingWizard/doc-review-bg.svg'
import LegalAdviceBg from '../../../../assets/MemberBookingWizard/legal-advice-bg.svg'
import { BookingCategoryRadioOption } from './BookingCategoryRadioOption'
import { ImClipboard } from 'react-icons/im'
import { PersonChat } from 'assets/icons/PersonChat'
import { ModalFooter } from '../../../../../../common/components/wizard/ModalFooter'
import { SimpleErrorMessage } from '../common/SimpleErrorMessage'
import { BookingCategory, BookingCategoryLabels } from 'common/types/MemberBooking'
import * as yup from 'yup'

interface Step1BookingCategoryProps {
  bookingCategory: BookingCategory | null
  setBookingCategory: (type: BookingCategory) => void
}

const validationSchema = yup.object().shape({
  bookingCategory: yup.mixed<BookingCategory>().oneOf(
    Object.values(BookingCategory),
    'You must select one option',
  ),
})

// NOTE: It's such a simple component that we don't need RHF here

export const Step1BookingCategory = ({
  bookingCategory,
  setBookingCategory,
}: Step1BookingCategoryProps) => {
  const [error, setError] = useState<yup.ValidationError | null>(null)

  const handleRadioSelect = (option: BookingCategory) => {
    setBookingCategory(option)
    setError(null)
  }

  const doValidation = async () => {
    try {
      await validationSchema.validate({ bookingCategory })
      setError(null)
      return true
    } catch (error) {
      setError(error)
      return false
    }
  }

  return (
    <>
      <div className='mb-4'>
        <p className='text-[#25395C] mb-12 text-sm sm:text-base font-normal sm:font-medium tracking-wide'>
          Let us know what type of booking you would like to make
        </p>
      </div>
      <div className='flex flex-col place-items-center md:flex-row justify-center gap-11 mb-4'>
        <BookingCategoryRadioOption
          titleText={BookingCategoryLabels[BookingCategory.DOCUMENT_REVIEW]}
          bodyText='Have an expert review and report back on your draft document.'
          backgroundImage={DocReviewBg}
          selected={bookingCategory === BookingCategory.DOCUMENT_REVIEW}
          onSelect={() => handleRadioSelect(BookingCategory.DOCUMENT_REVIEW)}
          selectedBorderColor='border-[#65C2D7]'
          Icon={ImClipboard}
        />
        <BookingCategoryRadioOption
          titleText={BookingCategoryLabels[BookingCategory.LEGAL_ADVICE]}
          bodyText='Legal advice and representation for your legal issue.'
          backgroundImage={LegalAdviceBg}
          selected={bookingCategory === BookingCategory.LEGAL_ADVICE}
          onSelect={() => handleRadioSelect(BookingCategory.LEGAL_ADVICE)}
          selectedBorderColor='border-[#7B7BDF]'
          Icon={PersonChat}
        />
      </div>
      {error && <SimpleErrorMessage message={error.message} />}
      <ModalFooter backButtonHide={true} doBeforeNextStep={doValidation} />
    </>
  )
}
